import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CurrentUserService } from 'src/app/user/services';
import { MonitorGroup } from '../../models/monitor-group';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';

interface ShowType {
  id: number;
  name: string;
}

@Component({
    selector: 'app-monitor-groups-grid',
    templateUrl: './monitor-groups-grid.component.html',
    styleUrls: ['./monitor-groups-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxTemplateModule, ChangeLogLinkComponent, ChangeLogLinkEntityDirective]
})
export class MonitorGroupsGridComponent implements OnInit {
  @Input() groups: MonitorGroup[] = [];
  @Output() saveGroup = new EventEmitter<MonitorGroup>();
  @Output() deleteGroup = new EventEmitter<MonitorGroup>();

  allowAdding = false;
  allowUpdating = false;
  allowDeleting = false;
  allowShowLog = false;

  showTypes: ShowType[] = [
    { id: 1, name: 'Show All' },
    { id: 2, name: 'Show Warnings' },
    { id: 3, name: 'Show Errors' },
    { id: 4, name: 'Always Collapsed' }
  ];

  constructor(
    private currentUserService: CurrentUserService,
    public bizGridFiltervalues: BizGridFiltervalues) {
  }

  ngOnInit(): void {
    this.allowAdding = this.currentUserService.hasPermission('Monitor_Action_Group_Create');
    this.allowUpdating = this.currentUserService.hasPermission('Monitor_Action_Group_Edit');
    this.allowDeleting = this.currentUserService.hasPermission('Monitor_Action_Group_Delete');
    this.allowShowLog = this.currentUserService.hasPermission('Monitor_Action_ShowLog');
  }

  onInitNewRow(ev: any): void {
    ev.data = { id: 0, name: '', description: '', showType: 1, sortOrder: 0 } as MonitorGroup;
  }

  async onRowInserted(ev: any): Promise<void> {
    const group = ev.data as MonitorGroup;
    this.saveGroup.emit(group);
  }

  async onRowUpdated(ev: any): Promise<void> {
    const group = ev.data as MonitorGroup;
    this.saveGroup.emit(group);
  }

  async onRowRemoving(ev: any): Promise<void> {
    const group = ev.data as MonitorGroup;
    this.deleteGroup.emit(group);
  }
}
